import { Divider, Switch, Field, Slider } from '@fluentui/react-components';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AppEdit3DContentFormFields } from './editContent';

export default function AppView3DConfig() {
  const formHandlers = useFormContext<AppEdit3DContentFormFields>();

  return (
    <>
      <Divider>View</Divider>
      <Switch
        label="Save current camera position"
        labelPosition="before"
        {...formHandlers.register('model.saveViewState')}
      />
      <Field label="Pitch" orientation="horizontal">
        <Slider min={0} max={90} />
      </Field>
      <Field label="Roll" orientation="horizontal">
        <Slider min={0} max={90} />
      </Field>
    </>
  );
}
